import Toast from 'bootstrap/js/src/toast';
import {parseHTML} from "../Core/common";

export const notice = (message, delay = 4000, color = 'text-bg-info') => {
    let container = document.querySelector('.js_toast_container');
    if (!container) {
        container = parseHTML(`<div aria-live="polite" aria-atomic="true">
                                        <div class="toast-container position-fixed top-0 end-0 p-3 js_toast_container" style="z-index: 10000;"> 
                                        </div>
                                    </div>`);

        document.querySelector('body').append(container);
        container = document.querySelector('.js_toast_container');
    }

    let id = Math.random().toString().substring(2);

    let element = parseHTML(`<div class="toast align-items-center ${color} text-white bg-main border-0" id="toast_${id}" role="alert" aria-live="assertive" data-bs-animation="true" data-bs-delay="${delay}" aria-atomic="true">
                                        <div class="d-flex align-items-center">
                                            <div class="toast-body">
                                                ${message}                                                
                                            </div>
                                            <button type="button" class="bg-transparent border-0 ms-auto d-flex text-white basket-item-close btn-close btn-close-white pe-2" data-bs-dismiss="toast" aria-label="Close">
                                                    <i class="Close icon fs-20 lh-1 text-white"></i> 
                                            </button>                                                
                                        </div>
                                    </div>`);

    container.append(element);

    let to = document.querySelector(`#toast_${id}`);
    let t = new Toast(to);
    t.show();

    to.addEventListener('hidden.bs.toast', () => to.remove());
};